export enum StorageFileType {
    VOICE_FILE = "Звуковой файл", MOH = "Музыка ожидания"
}
